import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { getDefaultUserMeTenant } from '@/features/auth/models'
import { fetchPackageCategoryImportJobs } from '@/features/package-category-import-jobs/api'
import { USER_TYPE } from '@/libs/api/types'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { packageCategoryImportJobsSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/package-category-import-jobs/'
)({
  validateSearch: (search) =>
    parse(packageCategoryImportJobsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    if (auth.user.type === USER_TYPE.PARTNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
    return {
      packageCategoryImportJobs: await fetchPackageCategoryImportJobs(
        { tenantKey, query: { ...deps, dcId: deps.dcId! } },
        abortController.signal
      )
    }
  }
})
